(function () {
  'use strict';
  if (window.CerusPdp && window.CerusPdp.loaded) return;

  var CerusPdp = window.CerusPdp = { loaded: true };

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    var value = (cents / 100);
    var fmt = format || '${{amount}}';
    function withCommas(num) {
      var parts = num.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, key) {
      switch (key) {
        case 'amount': return withCommas(value.toFixed(2));
        case 'amount_no_decimals': return withCommas(Math.round(value).toString());
        case 'amount_with_comma_separator': return value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        case 'amount_no_decimals_with_comma_separator': return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        case 'amount_with_apostrophe_separator': return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'");
        default: return withCommas(value.toFixed(2));
      }
    });
  }

  function getAutoScroll() {
    if (window.splide && window.splide.Extensions && window.splide.Extensions.AutoScroll) return window.splide.Extensions.AutoScroll;
    if (window.AutoScroll) return window.AutoScroll;
    return null;
  }

  function wrapSymbols(root) {
    if (!root) return;
    var SYMS = '®©™†‡§¶★';
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (node.parentNode && node.parentNode.tagName === 'SUP') return NodeFilter.FILTER_REJECT;
        if (node.parentNode && /SCRIPT|STYLE|TEXTAREA|INPUT/.test(node.parentNode.tagName)) return NodeFilter.FILTER_REJECT;
        for (var i = 0; i < SYMS.length; i++) {
          if (node.nodeValue.indexOf(SYMS[i]) !== -1) return NodeFilter.FILTER_ACCEPT;
        }
        return NodeFilter.FILTER_REJECT;
      }
    });
    var batch = [];
    var n;
    while ((n = walker.nextNode())) batch.push(n);
    batch.forEach(function (node) {
      var text = node.nodeValue;
      var frag = document.createDocumentFragment();
      var buf = '';
      for (var i = 0; i < text.length; i++) {
        var ch = text[i];
        if (SYMS.indexOf(ch) !== -1) {
          if (buf) { frag.appendChild(document.createTextNode(buf)); buf = ''; }
          var sup = document.createElement('sup');
          sup.className = 'cerus-sup';
          sup.textContent = ch;
          frag.appendChild(sup);
        } else {
          buf += ch;
        }
      }
      if (buf) frag.appendChild(document.createTextNode(buf));
      node.parentNode.replaceChild(frag, node);
    });
  }



  var TITLE_CASE_SKIP = {
    a: 1, an: 1, the: 1, and: 1, or: 1, but: 1, nor: 1, of: 1, in: 1,
    on: 1, at: 1, to: 1, for: 1, by: 1, it: 1, is: 1, as: 1, with: 1,
    from: 1, etc: 1, vs: 1, via: 1, per: 1
  };

  function toTitleCase(str) {
    if (!str) return str;
    var words = str.split(/(\s+)/);
    var firstWordIdx = -1;
    for (var i = 0; i < words.length; i++) {
      if (/\S/.test(words[i])) { firstWordIdx = i; break; }
    }
    return words.map(function (word, i) {
      if (!/\S/.test(word)) return word;

      var stripped = word.replace(/[^A-Za-z]/g, '');
      if (stripped.length > 1 && stripped === stripped.toUpperCase()) return word;
      var lower = word.toLowerCase();
      var lookup = lower.replace(/[^a-z]/g, '');
      if (i !== firstWordIdx && TITLE_CASE_SKIP[lookup]) return lower;

      return lower.replace(/([a-z])/, function (m) { return m.toUpperCase(); });
    }).join('');
  }

  function titleCaseBenefits(root) {
    if (!root) return;
    $all('.cerus-buybox__benefits li > span', root).forEach(function (el) {
      if (el.dataset.cerusTitleCased === '1') return;

      var changed = false;
      var nodes = [];
      el.childNodes.forEach(function (n) { nodes.push(n); });
      nodes.forEach(function (n) {
        if (n.nodeType === 3 && n.nodeValue && n.nodeValue.trim()) {
          var cased = toTitleCase(n.nodeValue);
          if (cased !== n.nodeValue) { n.nodeValue = cased; changed = true; }
        }
      });
      if (changed) el.dataset.cerusTitleCased = '1';
    });
  }

  function bindAccordions(root) {
    $all('[data-cerus-accordion-trigger]', root).forEach(function (trigger) {
      if (trigger.dataset.cerusBound) return;
      trigger.dataset.cerusBound = '1';
      trigger.addEventListener('click', function () {
        var accordion = trigger.closest('[data-cerus-accordion]');
        if (!accordion) return;
        var group = accordion.closest('[data-cerus-accordion-group]') || accordion.parentNode;
        var wasOpen = accordion.classList.contains('is-open');
        if (group) {
          $all('[data-cerus-accordion]', group).forEach(function (a) {
            if (a === accordion) return;
            a.classList.remove('is-open');
            var t = a.querySelector('[data-cerus-accordion-trigger]');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
        }
        var open = !wasOpen;
        accordion.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function bindReveals(section) {
    if (!section.hasAttribute('data-cerus-reveal')) return;
    $all('.cerus-reveal', section).forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i * 70, 560) + 'ms';
    });
    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-revealed');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05 });
    io.observe(section);
    setTimeout(function () {
      if (!section.classList.contains('is-revealed')) section.classList.add('is-revealed');
    }, 1200);
  }

  function bindParallax(section) {
    var layer = $('[data-cerus-parallax] .cerus-section__bg-media', section);
    if (!layer) return;
    if (window.gsap && window.ScrollTrigger) {
      window.gsap.registerPlugin(window.ScrollTrigger);
      window.gsap.fromTo(layer, { yPercent: -10 }, {
        yPercent: 10, ease: 'none',
        scrollTrigger: { trigger: section, start: 'top bottom', end: 'bottom top', scrub: true }
      });
      return;
    }
    var ticking = false;
    function update() {
      var rect = section.getBoundingClientRect();
      var progress = (rect.top + rect.height) / (window.innerHeight + rect.height);
      layer.style.transform = 'translate3d(0,' + ((progress - 0.5) * 14) + '%,0)';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function mountSplide(el, options, withAutoScroll) {
    if (!window.Splide || !el || el.dataset.cerusSplide) return null;
    el.dataset.cerusSplide = '1';
    var splide = new window.Splide(el, options);
    var ext = {};
    var as = getAutoScroll();
    if (withAutoScroll && as) ext.AutoScroll = as;
    splide.mount(ext);
    return splide;
  }

  function initMarquee(section) {
    var el = $('[data-cerus-marquee]', section);
    if (!el) return;
    var speed = parseFloat(el.dataset.speed || '0.8');
    var reverse = el.dataset.direction === 'right';
    mountSplide(el, {
      type: 'loop', drag: 'free', focus: 'center', perPage: 1, autoWidth: true,
      arrows: false, pagination: false, gap: 0, clones: 8,
      autoScroll: { speed: reverse ? -speed : speed, pauseOnHover: true, pauseOnFocus: false, rewind: false }
    }, true);
  }

  function initReviews(section) {
    var el = $('[data-cerus-reviews]', section);
    if (!el) return;
    var list = $('[data-cerus-reviews-list]', el);
    var count = list ? list.children.length : 0;
    var empty = $('[data-cerus-reviews-empty]', section);
    if (!count) {
      if (empty) empty.hidden = false;
      el.style.display = 'none';
      return;
    }
    if (count <= 1) el.classList.add('is-single');
    var loop = count > 3;
    var perPage = Math.min(3, Math.max(1, count));
    var splide = mountSplide(el, {
      type: loop ? 'loop' : 'slide',
      drag: count > 1 ? 'free' : false,
      perPage: perPage,
      gap: '20px',
      arrows: count > 1,
      pagination: false,
      focus: 'center',
      autoScroll: loop ? { speed: 0.7, pauseOnHover: true, pauseOnFocus: false } : false,
      breakpoints: {
        1100: { perPage: Math.min(2, count) },
        749: { perPage: 1, arrows: false }
      }
    }, loop);
    setTimeout(function () { if (splide) splide.refresh(); }, 60);
  }

  function initIngredients(section) {
    var el = $('[data-cerus-ingredients]', section);
    if (el) {
      var count = el.querySelectorAll('.splide__slide').length;
      mountSplide(el, {
        type: count > 3 ? 'loop' : 'slide',
        drag: true,
        perPage: Math.min(3, count),
        perMove: 1,
        gap: '20px',



        focus: 0,
        start: 0,
        omitEnd: true,
        padding: { left: 2, right: 2 },
        pagination: false,
        arrows: count > 3,
        breakpoints: {
          990: { perPage: Math.min(2, count), arrows: count > 2 },
          749: { perPage: 1, arrows: count > 1 }
        }
      }, false);
    }
    $all('[data-cerus-ingredient-toggle]', section).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-cerus-ingredient]');
        if (!card) return;
        var open = card.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var label = btn.querySelector('span');
        if (label) label.textContent = open ? 'Hide' : 'Learn More';
      });
    });
  }

  function initFaq(section) {
    bindAccordions(section);
    var viewer = $('[data-cerus-3d]', section);
    if (!viewer) return;
    function openViewer() {
      if (window.cerusModelViewer) {
        window.cerusModelViewer.open(viewer);
      } else {
        setTimeout(openViewer, 200);
      }
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            openViewer();
            io.disconnect();
          }
        });
      }, { threshold: 0.25 });
      io.observe(viewer);
    } else {
      openViewer();
    }
    document.addEventListener('cerus:variant-change', function (e) {
      var detail = e.detail || {};
      if (!window.cerusModelViewer) return;
      if (detail.variantId) {
        window.cerusModelViewer.setVariant(viewer, detail.variantId);
      } else if (detail.modelUrl) {
        viewer.dataset.modelUrl = detail.modelUrl;
        window.cerusModelViewer.open(viewer, detail.modelUrl);
      }
    });
  }

  function initSfpModal(section) {
    var trigger = $('[data-cerus-sfp-trigger]', section);
    var modal = $('[data-cerus-sfp-modal]', section);
    if (!trigger || !modal) return;
    var close = $('[data-cerus-sfp-close]', modal);
    function open() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function shut() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    trigger.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    modal.addEventListener('click', function (e) { if (e.target === modal) shut(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) shut();
    });
  }

  function initProduct(section) {
    var dataEl = $('[data-cerus-product-data]', section);
    if (!dataEl) {
      status('initProduct ABORT — no [data-cerus-product-data] script found');
      return;
    }
    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      status('initProduct ABORT — JSON parse failed:', e && e.message);
      return;
    }
    var variants = data.variants || [];
    var moneyFormat = data.moneyFormat || '${{amount}}';
    if (!variants.length) {
      status('initProduct ABORT — variants array is empty');
      return;
    }
    status('initProduct continuing — variants:', variants.length, 'moneyFormat:', moneyFormat);

    wrapSymbols(section);

    var form = $('[data-cerus-form]', section);
    var variantInput = $('[data-cerus-variant-id]', section);
    var priceEl = $('[data-cerus-price]', section);
    var compareEl = $('[data-cerus-compare]', section);
    var saveEl = $('[data-cerus-save]', section);
    var perDayEl = $('[data-cerus-per-day]', section);
    var atcBtn = $('[data-cerus-atc]', section);
    var atcLabel = $('[data-cerus-atc-label]', section);
    var atcPrice = $('[data-cerus-atc-price]', section);
    var purchase = $('[data-cerus-purchase]', section);
    var briefEl = $('[data-cerus-brief]', section);

    var state = {
      variant: variants.filter(function (v) { return String(v.id) === String(variantInput && variantInput.value); })[0] || variants[0],
      mode: 'onetime',
      sellingPlanId: null
    };

    function getSelectedOptions() {
      var opts = [];
      $all('[data-cerus-option]', section).forEach(function (group) {
        var pos = parseInt(group.dataset.optionPosition, 10);
        var checked = group.querySelector('input:checked');
        if (checked) opts[pos - 1] = checked.value;
      });
      $all('[data-cerus-hidden-option]', section).forEach(function (input) {
        var pos = parseInt(input.dataset.optionPosition, 10);
        opts[pos - 1] = input.value;
      });
      return opts;
    }

    function matchVariant(opts) {
      return variants.filter(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      })[0];
    }

    function currentAllocation() {
      if (!state.sellingPlanId || !state.variant.sellingPlanAllocations) return null;
      return state.variant.sellingPlanAllocations.filter(function (a) {
        return String(a.sellingPlanId) === String(state.sellingPlanId);
      })[0];
    }

    function activePrice() {
      if (state.mode === 'subscription') {
        var alloc = currentAllocation();
        if (alloc) return alloc.price;
      }
      return state.variant.price;
    }

    function renderPrice() {
      var price = activePrice();
      var compare = state.variant.compareAt;
      if (priceEl) priceEl.textContent = formatMoney(price, moneyFormat);
      if (atcPrice) atcPrice.textContent = formatMoney(price, moneyFormat);

      var baseCompare = compare && compare > state.variant.price ? compare : 0;
      if (state.mode === 'subscription') baseCompare = state.variant.price;
      var showCompare = baseCompare && baseCompare > price;
      if (compareEl) {
        compareEl.hidden = !showCompare;
        if (showCompare) compareEl.textContent = formatMoney(baseCompare, moneyFormat);
      }
      if (saveEl) {


        if (showCompare && state.mode === 'subscription') {
          saveEl.hidden = false;
          saveEl.textContent = 'Save ' + Math.round((1 - price / baseCompare) * 100) + '%';
        } else {
          saveEl.hidden = true;
        }
      }

      var priceBlock = section.querySelector('[data-cerus-price-block]');
      if (priceBlock) priceBlock.dataset.mode = state.mode;

      var modeOtp = $('[data-cerus-mode-price="onetime"]', section);
      var modeSub = $('[data-cerus-mode-price="subscription"]', section);
      if (modeOtp) modeOtp.textContent = formatMoney(state.variant.price, moneyFormat);
      if (modeSub) {
        var firstAlloc = state.variant.sellingPlanAllocations && state.variant.sellingPlanAllocations[0];
        var subPlan = currentAllocation() || firstAlloc;

        modeSub.textContent = subPlan
          ? formatMoney(subPlan.price, moneyFormat)
          : formatMoney(state.variant.price, moneyFormat);
      }

      var subTag = $('[data-cerus-sub-tag]', section);
      if (subTag) {
        var alloc2 = currentAllocation() || (state.variant.sellingPlanAllocations || [])[0];
        if (alloc2 && alloc2.price < state.variant.price) {
          subTag.textContent = 'Get ' + Math.round((1 - alloc2.price / state.variant.price) * 100) + '% Off';
        } else { subTag.textContent = ''; }
      }

      var modeSubCompare = $('[data-cerus-mode-compare="subscription"]', section);
      if (modeSubCompare) {
        var allocCmp = currentAllocation() || (state.variant.sellingPlanAllocations || [])[0];
        if (allocCmp && allocCmp.price < state.variant.price) {
          modeSubCompare.textContent = formatMoney(state.variant.price, moneyFormat);
          modeSubCompare.hidden = false;
        } else {
          modeSubCompare.textContent = '';
          modeSubCompare.hidden = true;
        }
      }

      renderPerDay(price);
    }

    function getServingsCount() {
      var raw = String(state.variant.servings || '');
      var matches = raw.match(/\d+/g);
      if (matches && matches.length) return parseInt(matches[0], 10);
      return 0;
    }

    function renderPerDay(price) {
      if (!purchase) return;
      var servings = getServingsCount();
      var subPerDayEl = $('[data-cerus-sub-perday]', section);
      var otpPerDayEl = $('[data-cerus-otp-perday]', section);

      if (servings > 0) {
        var otpUnit = formatMoney(Math.round(state.variant.price / servings), moneyFormat);
        if (otpPerDayEl) otpPerDayEl.textContent = otpUnit + '/serving';
        var subBase = state.variant.price;
        var alloc = currentAllocation() || (state.variant.sellingPlanAllocations || [])[0];
        if (alloc) subBase = alloc.price;
        var subUnit = formatMoney(Math.round(subBase / servings), moneyFormat);
        if (subPerDayEl) subPerDayEl.textContent = subUnit + '/serving';
      } else {
        if (otpPerDayEl) otpPerDayEl.textContent = '';
        if (subPerDayEl) subPerDayEl.textContent = '';
      }

      if (perDayEl) {
        var enabled = state.mode === 'subscription'
          ? purchase.dataset.subPerday === 'true'
          : purchase.dataset.otpPerday === 'true';
        if (enabled && servings > 0) {
          perDayEl.hidden = false;
          perDayEl.textContent = formatMoney(Math.round(price / servings), moneyFormat) + ' per serving';
        } else {
          perDayEl.hidden = true;
        }
      }

      var otpDelivery = $('[data-cerus-otp-delivery]', section);
      var subDelivery = $('[data-cerus-sub-delivery]', section);
      var qty = parseInt(($('[data-cerus-qty-input]', section) || {}).value || 1, 10) || 1;
      var unit = qty === 1 ? 'pack' : 'packs';
      if (otpDelivery) otpDelivery.textContent = qty + ' ' + unit + ' delivered once';
      if (subDelivery) {
        var planEl = $('[data-cerus-plan-select]', section);
        var planLabel = planEl && planEl.options[planEl.selectedIndex] ? planEl.options[planEl.selectedIndex].textContent : 'each cycle';
        subDelivery.textContent = qty + ' ' + unit + ' ' + planLabel.toLowerCase();
      }
    }

    function renderVariantContent() {
      var id = state.variant.id;
      $all('[data-cerus-sfp-panel]', section).forEach(function (p) {
        p.hidden = String(p.dataset.cerusSfpPanel) !== String(id);
      });
      $all('[data-cerus-use-panel]', section).forEach(function (p) {
        p.hidden = String(p.dataset.cerusUsePanel) !== String(id);
      });
      $all('[data-cerus-coa-panel]', section).forEach(function (p) {
        p.hidden = String(p.dataset.cerusCoaPanel) !== String(id);
      });
      $all('[data-cerus-sfp-chip]', section).forEach(function (chip) {
        chip.classList.toggle('is-active', String(chip.dataset.variantId) === String(id));
      });
      var coaSelect = $('[data-cerus-coa-select]', section);
      if (coaSelect) coaSelect.value = id;

      if (briefEl && state.variant.shortDescription) {
        briefEl.innerHTML = state.variant.shortDescription.replace(/\n/g, '<br>');
        wrapSymbols(briefEl);
      }
      var titleEl = $('[data-cerus-title]', section);
      if (titleEl && state.variant.shortTitle) {
        titleEl.textContent = state.variant.shortTitle;
        wrapSymbols(titleEl);
      }
      var subheaderEl = $('[data-cerus-subheader]', section);
      if (subheaderEl) {
        var sub = state.variant.subheader || '';
        if (sub) {
          subheaderEl.textContent = sub;
          subheaderEl.hidden = false;
          wrapSymbols(subheaderEl);
        } else if (!subheaderEl.dataset.cerusFallback) {
          subheaderEl.hidden = true;
        } else {
          subheaderEl.textContent = subheaderEl.dataset.cerusFallback;
          subheaderEl.hidden = false;
          wrapSymbols(subheaderEl);
        }
      }
      var informed = $('[data-cerus-informed-sport]', section);
      if (informed) informed.hidden = !state.variant.informedSport;

      if (informed && !informed.__cerusSealBound) {
        informed.__cerusSealBound = true;
        informed.addEventListener('click', function (e) {
          e.preventDefault();
          var isOpen = informed.getAttribute('aria-expanded') === 'true';
          informed.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        });
        document.addEventListener('click', function (e) {
          if (informed.getAttribute('aria-expanded') !== 'true') return;
          if (e.target === informed || informed.contains(e.target)) return;
          informed.setAttribute('aria-expanded', 'false');
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && informed.getAttribute('aria-expanded') === 'true') {
            informed.setAttribute('aria-expanded', 'false');
          }
        });
      }



      var hex = (state.variant && state.variant.accent) || '';
      if (!hex) hex = (data.fallbackAccent || '#0c0c0c');
      var rgb = hexToRgb(hex);
      section.style.setProperty('--cerus-accent', hex);
      section.style.setProperty('--cerus-cta-accent-bg', hex);
      section.style.setProperty('--cerus-cta-accent-bg-hover', hex);
      document.documentElement.style.setProperty('--cerus-accent', hex);
      if (rgb) {
        var soft = 'rgba(' + rgb + ',0.12)';
        var glow = 'rgba(' + rgb + ',0.35)';
        section.style.setProperty('--cerus-accent-soft', soft);
        section.style.setProperty('--cerus-accent-glow', glow);
        document.documentElement.style.setProperty('--cerus-accent-soft', soft);
        document.documentElement.style.setProperty('--cerus-accent-glow', glow);
      }
      var isMetallic = isGoldAccent(hex);
      document.documentElement.classList.toggle('cerus-accent--metallic', isMetallic);
      section.classList.toggle('cerus-accent--metallic', isMetallic);

      document.dispatchEvent(new CustomEvent('cerus:variant-change', {
        bubbles: true,
        detail: {
          variantId: state.variant.id,
          modelUrl: state.variant.modelUrl || '',
          accent: state.variant.accent || '',
          imageSrc: state.variant.imageSrc || '',
          swatchImage: state.variant.swatchImage || '',
          title: state.variant.shortTitle || ''
        }
      }));
    }

    function hexToRgb(hex) {
      var m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return m ? parseInt(m[1], 16) + ',' + parseInt(m[2], 16) + ',' + parseInt(m[3], 16) : null;
    }

    function isGoldAccent(hex) {
      var m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || '');
      if (!m) return false;
      var r = parseInt(m[1], 16), g = parseInt(m[2], 16), b = parseInt(m[3], 16);
      return r > 140 && r < 230 && g > 110 && g < 200 && b > 40 && b < 140 && r > g && g > b && (r - b) > 50;
    }

    function renderGallery() {
      var mediaId = state.variant.featuredMediaId;
      if (mediaId) {
        var slide = $('[data-media-id="' + mediaId + '"]', section);
        if (slide) {
          selectMedia(parseInt(slide.dataset.mediaIndex, 10));
          return;
        }
      }
      if (state.variant.imageSrc) {
        var firstSlide = $('[data-cerus-slide]', section);
        if (firstSlide) {
          var img = firstSlide.querySelector('img');
          if (img) {
            img.src = state.variant.imageSrc;
            img.removeAttribute('srcset');
          }
          selectMedia(0);
        }
      }
    }

    function renderAtc() {
      if (atcBtn) {
        atcBtn.disabled = !state.variant.available;
        if (atcLabel) atcLabel.textContent = state.variant.available ? 'Add to cart' : 'Sold out';




        var accent = state.variant && state.variant.accent;
        atcBtn.style.removeProperty('--cerus-cta-accent-border');
        atcBtn.style.removeProperty('--cerus-cta-accent-border-hover');
        if (accent) {
          atcBtn.style.setProperty('--cerus-cta-accent-bg', accent);
          atcBtn.style.setProperty('--cerus-cta-accent-bg-hover', accent);
          atcBtn.dataset.cerusAtcColor = accent;
        } else {
          atcBtn.style.removeProperty('--cerus-cta-accent-bg');
          atcBtn.style.removeProperty('--cerus-cta-accent-bg-hover');
        }
      }
    }

    function syncOptionLabels() {
      $all('[data-cerus-option]', section).forEach(function (group) {
        var pos = parseInt(group.dataset.optionPosition, 10);
        var expected = state.variant && state.variant.options ? state.variant.options[pos - 1] : null;
        $all('input[type="radio"]', group).forEach(function (input) {
          var match = expected != null && input.value === expected;
          if (match) input.checked = true;
        });
        var checked = group.querySelector('input:checked');
        var label = group.querySelector('[data-cerus-option-selected]');
        if (checked && label) label.textContent = checked.value;
        else if (expected && label) label.textContent = expected;
        $all('[data-cerus-swatch]', group).forEach(function (sw) {
          var input = sw.querySelector('input');
          sw.classList.toggle('is-active', input && input.checked);
        });
      });
      $all('[data-cerus-hidden-option]', section).forEach(function (input) {
        var pos = parseInt(input.dataset.optionPosition, 10);
        if (state.variant && state.variant.options && state.variant.options[pos - 1]) {
          input.value = state.variant.options[pos - 1];
        }
      });
    }

    function setVariant(variant) {
      if (!variant) return;
      state.variant = variant;
      if (variantInput) variantInput.value = variant.id;
      syncOptionLabels();
      renderPrice();
      renderAtc();
      renderVariantContent();
      renderGallery();
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    function syncSelectorsToVariant(variant) {
      var v_opts = variant.options || [];
      $all('[data-cerus-option]', section).forEach(function (group) {
        var pos = parseInt(group.dataset.optionPosition, 10);
        var wantVal = v_opts[pos - 1];
        $all('input', group).forEach(function (i) {
          var shouldCheck = i.value === wantVal;
          if (i.checked !== shouldCheck) i.checked = shouldCheck;
          var label = i.closest('.cerus-pill, .cerus-flavor');
          if (label) label.classList.toggle('is-active', shouldCheck);
        });
      });
      $all('[data-cerus-hidden-option]', section).forEach(function (input) {
        var pos = parseInt(input.dataset.optionPosition, 10);
        input.value = v_opts[pos - 1] || input.value;
      });
    }

    $all('[data-cerus-option] input', section).forEach(function (input) {
      input.addEventListener('change', function () {
        var group = input.closest('[data-cerus-option]');
        var changedPos = group ? parseInt(group.dataset.optionPosition, 10) : 0;
        var changedVal = input.value;
        var opts = getSelectedOptions();
        var match = matchVariant(opts);
        if (!match && changedPos) {
          match = variants.filter(function (v) {
            return v.available && v.options[changedPos - 1] === changedVal;
          })[0];
          if (!match) {
            match = variants.filter(function (v) {
              return v.options[changedPos - 1] === changedVal;
            })[0];
          }
          if (match) syncSelectorsToVariant(match);
        }
        if (match) {
          setVariant(match);
        } else {
          syncOptionLabels();
          if (atcBtn) { atcBtn.disabled = true; }
          if (atcLabel) atcLabel.textContent = 'Unavailable';
        }
      });
    });

    function setMode(mode) {
      state.mode = mode;
      $all('[data-cerus-mode]', section).forEach(function (opt) {
        opt.classList.toggle('is-active', opt.dataset.cerusMode === mode);
      });
      var plans = $('[data-cerus-plans]', section);
      if (plans) plans.style.display = mode === 'subscription' ? '' : 'none';
      if (mode === 'subscription') {
        var planEl = $('[data-cerus-plan-select]', section);
        state.sellingPlanId = planEl ? planEl.value : ((state.variant.sellingPlanAllocations || [])[0] || {}).sellingPlanId;
      } else {
        state.sellingPlanId = null;
      }
      var discountBox = $('[data-cerus-discount-box]', section);
      if (discountBox) discountBox.hidden = mode !== 'subscription';
      renderPrice();
    }

    var purchaseModeInputs = $all('[name="cerus-purchase-mode"]', section);
    var purchaseOptions = $all('[data-cerus-mode]', section);
    status('purchase handlers bound', { radioCount: purchaseModeInputs.length, optionCount: purchaseOptions.length, optionModes: purchaseOptions.map(function (o) { return o.dataset.cerusMode; }) });
    purchaseModeInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        status('purchase-mode CHANGE →', input.value);
        setMode(input.value);
      });
    });
    purchaseOptions.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        status('purchase-option CLICK on', opt.dataset.cerusMode, '— target:', e.target.tagName + (e.target.className ? '.' + String(e.target.className).split(/\s+/).slice(0, 2).join('.') : ''));
        if (e.target.closest('.cerus-purchase__plan')) return;
        var radio = opt.querySelector('[name="cerus-purchase-mode"]');
        if (radio && !radio.checked) { radio.checked = true; setMode(radio.value); }
      });
    });
    var planSelect = $('[data-cerus-plan-select]', section);
    if (planSelect) {
      planSelect.addEventListener('change', function () {
        state.sellingPlanId = planSelect.value;
        renderPrice();
      });
    }

    $all('[data-cerus-sfp-chip]', section).forEach(function (chip) {
      chip.addEventListener('click', function () {
        var id = chip.dataset.variantId;
        var match = variants.filter(function (v) { return String(v.id) === String(id); })[0];
        if (match) setVariant(match);
      });
    });
    var coaSelect = $('[data-cerus-coa-select]', section);
    if (coaSelect) {
      coaSelect.addEventListener('change', function () {
        $all('[data-cerus-coa-panel]', section).forEach(function (p) {
          p.hidden = String(p.dataset.cerusCoaPanel) !== coaSelect.value;
        });
      });
    }

    var qtyInput = $('[data-cerus-qty-input]', section);
    var qtyDown = $('[data-cerus-qty-down]', section);
    var qtyUp = $('[data-cerus-qty-up]', section);
    function clampQty() {
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      qtyInput.value = v;
    }
    if (qtyDown) qtyDown.addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      renderPrice();
    });
    if (qtyUp) qtyUp.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      renderPrice();
    });
    if (qtyInput) qtyInput.addEventListener('change', function () {
      clampQty();
      renderPrice();
    });

    var stripSplide = null;
    function getMediaCount() {
      return $all('[data-cerus-slide]', section).length;
    }
    function getActiveMediaIndex() {
      var slides = $all('[data-cerus-slide]', section);
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-active')) return i;
      }
      return 0;
    }
    function selectMedia(index) {
      var total = getMediaCount();
      if (total === 0) return;
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      $all('[data-cerus-slide]', section).forEach(function (s) {
        s.classList.toggle('is-active', parseInt(s.dataset.mediaIndex, 10) === index);
      });
      $all('[data-cerus-thumb]', section).forEach(function (t) {
        t.classList.toggle('is-active', parseInt(t.dataset.mediaIndex, 10) === index);
      });
      if (stripSplide) {
        try { stripSplide.go(index); } catch (e) {}
      }
    }

    function isLinkable(v) {
      return v && v.available !== false && v.hideVariant !== true;
    }



    function syncVariantToMediaIndex(mediaIndex, rawVariantIdHint) {



      var variantId = rawVariantIdHint || '';
      var slide = section.querySelector('[data-cerus-slide][data-media-index="' + mediaIndex + '"]');

      if (!variantId) {
        var mediaId = slide && slide.dataset.mediaId;
        if (mediaId) {
          for (var k = 0; k < variants.length; k++) {
            if (!isLinkable(variants[k])) continue;
            if (String(variants[k].featuredMediaId) === String(mediaId)) {
              variantId = variants[k].id;
              break;
            }
          }
        }
        if (!variantId && slide) {
          var slideImg = slide.querySelector('img');
          var slideSrc = (slideImg && (slideImg.currentSrc || slideImg.src)) || '';
          if (slideSrc) {
            var baseSrc = slideSrc.split('?')[0];
            for (var m = 0; m < variants.length; m++) {
              if (!isLinkable(variants[m])) continue;
              var vSrc = (variants[m].imageSrc || '').split('?')[0];
              if (vSrc && baseSrc.indexOf(vSrc.substring(vSrc.lastIndexOf('/') + 1)) !== -1) {
                variantId = variants[m].id;
                break;
              }
            }
          }
        }
      }
      if (!variantId) { status('gallery sync — no available variant matches media', mediaIndex); return; }

      var targetVariant = null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(variantId)) { targetVariant = variants[i]; break; }
      }
      if (!targetVariant || !isLinkable(targetVariant)) {
        status('gallery sync — variant', variantId, 'sold out / hidden / unknown, not switching');
        return;
      }
      if (state.variant === targetVariant) return;
      status('gallery sync — switching to variant', targetVariant.id, targetVariant.title);



      (targetVariant.options || []).forEach(function (optVal, idx) {
        var pos = idx + 1;
        var inputs = Array.prototype.slice.call(section.querySelectorAll('input[name="option-' + pos + '"]'));
        var input = inputs.filter(function (el) { return el.value === optVal; })[0];
        if (!input || input.checked) return;
        var label = input.closest('label, .cerus-flavor, .cerus-pill');
        if (label && typeof label.click === 'function') {
          label.click();
        } else {
          input.checked = true;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      if (state.variant !== targetVariant) setVariant(targetVariant);
    }

    section.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-cerus-thumb]');
      if (!thumb) return;
      var mediaIndex = parseInt(thumb.dataset.mediaIndex, 10);
      status('thumb CLICK — mediaIndex:', mediaIndex, 'data-variant-id:', thumb.dataset.variantId);
      selectMedia(mediaIndex);
      syncVariantToMediaIndex(mediaIndex, thumb.dataset.variantId);
    });
    var strip = $('[data-cerus-gallery-strip]', section);
    if (strip) {
      var thumbCount = strip.querySelectorAll('.splide__slide').length;
      strip.setAttribute('data-count', thumbCount);
      var perPageDesktop = Math.min(6, Math.max(1, thumbCount));
      var enoughToScroll = thumbCount > 6;
      stripSplide = mountSplide(strip, {
        type: enoughToScroll ? 'loop' : 'slide',
        drag: true,
        fixedWidth: 96,
        gap: 14,
        focus: 0,
        perMove: 1,
        pagination: false,
        arrows: enoughToScroll,
        clones: enoughToScroll ? Math.max(thumbCount, perPageDesktop) : 0,
        breakpoints: {
          600: { fixedWidth: 72, gap: 10 }
        }
      }, false);
      strip.addEventListener('click', function (e) {
        var arrow = e.target.closest('.splide__arrow');
        if (!arrow) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var dir = arrow.classList.contains('splide__arrow--next') ? 1 : -1;
        var total = getMediaCount();
        var next = (getActiveMediaIndex() + dir + total) % total;
        status('gallery ARROW', dir > 0 ? 'NEXT' : 'PREV', '→ media index', next);
        selectMedia(next);

        var matchingThumb = section.querySelector('[data-cerus-thumb][data-media-index="' + next + '"]');
        syncVariantToMediaIndex(next, matchingThumb && matchingThumb.dataset.variantId);
      }, true);
    }

    initSfpModal(section);

    var viewToggle = $('[data-cerus-media-toggle]', section);
    if (viewToggle) {
      $all('button', viewToggle).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var view = btn.dataset.cerusView;
          $all('button', viewToggle).forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          var viewer = $('[data-cerus-3d]', section);
          if (!viewer) return;
          if (view === 'model') {
            viewer.classList.add('is-active');
            if (window.cerusModelViewer) {
              window.cerusModelViewer.open(viewer, state.variant.modelUrl || viewer.dataset.modelUrl);
            }
          } else {
            viewer.classList.remove('is-active');
          }
        });
      });
    }

    var fomoTimer = $('[data-cerus-fomo-timer]', section);
    if (fomoTimer) {
      var tick = function () {
        var now = new Date();
        var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
        var diff = Math.max(0, Math.floor((end - now) / 1000));
        var h = String(Math.floor(diff / 3600)).padStart(2, '0');
        var m = String(Math.floor((diff % 3600) / 60)).padStart(2, '0');
        var s = String(diff % 60).padStart(2, '0');
        fomoTimer.textContent = h + ':' + m + ':' + s;
      };
      tick();
      setInterval(tick, 1000);
    }

    state.adding = false;
    if (atcBtn) {
      atcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (state.adding) return;
        if (!state.variant.available || atcBtn.classList.contains('is-loading')) return;
        state.adding = true;
        clampQty();
        atcBtn.classList.add('is-loading');
        var item = {
          id: state.variant.id,
          quantity: parseInt(qtyInput ? qtyInput.value : 1, 10) || 1
        };
        if (state.mode === 'subscription' && state.sellingPlanId) {
          item.selling_plan = state.sellingPlanId;
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [item] })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        }).then(function () {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        }).then(function (cart) {
          openCart(cart);
        }).catch(function (err) {
          if (atcLabel) atcLabel.textContent = (err && err.description) ? err.description : 'Try again';
          setTimeout(function () { if (atcLabel) atcLabel.textContent = 'Add to cart'; }, 2600);
        }).then(function () {
          atcBtn.classList.remove('is-loading');
          state.adding = false;
        });
      });
    }

    var initialVariant = state.variant;
    if (initialVariant && initialVariant.accent) {
      var initRgb = hexToRgb(initialVariant.accent);
      document.documentElement.style.setProperty('--cerus-accent', initialVariant.accent);
      if (initRgb) {
        document.documentElement.style.setProperty('--cerus-accent-soft', 'rgba(' + initRgb + ',0.12)');
        document.documentElement.style.setProperty('--cerus-accent-glow', 'rgba(' + initRgb + ',0.35)');
      }
    }
    setVariant(initialVariant);
    if (purchase) {
      var defaultMode = section.querySelector('[name="cerus-purchase-mode"]:checked');
      setMode(defaultMode ? defaultMode.value : 'onetime');
    }
  }

  function openCart(cart) {
    $all('.cart-count-bubble span, [data-cart-count]').forEach(function (el) {
      if (cart && typeof cart.item_count === 'number') el.textContent = cart.item_count;
    });
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('rebuy:cart.change', { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    if (window.Rebuy && window.Rebuy.SmartCart) {
      try { if (window.Rebuy.SmartCart.refresh) window.Rebuy.SmartCart.refresh(); } catch (e) {}
      try { if (window.Rebuy.SmartCart.show) { window.Rebuy.SmartCart.show(); return; } } catch (e) {}
      try { if (window.Rebuy.SmartCart.open) { window.Rebuy.SmartCart.open(); return; } } catch (e) {}
    }
    var drawer = document.querySelector('cart-drawer, cart-notification');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    if (drawer && typeof drawer.show === 'function') { drawer.show(); }
  }



  var DEBUG_VERBOSE = /[?&]cerusDebug=1/.test(window.location.search);
  function status() {
    var args = ['[cerus-pdp]'].concat(Array.prototype.slice.call(arguments));
    try { console.log.apply(console, args); } catch (e) {}
  }
  function vdbg() {
    if (!DEBUG_VERBOSE) return;
    status.apply(null, arguments);
  }

  function initSection(section) {
    if (!section || section.dataset.cerusReady) return;
    section.dataset.cerusReady = '1';
    var type = section.getAttribute('data-cerus-component');
    bindAccordions(section);
    bindReveals(section);
    bindParallax(section);
    wrapSymbols(section);
    titleCaseBenefits(section);
    if (type === 'product') {
      status('initProduct →', section.id);
      try { initProduct(section); }
      catch (err) { console.error('[cerus-pdp] initProduct threw:', err); }
    }
    else if (type === 'marquee') initMarquee(section);
    else if (type === 'reviews') initReviews(section);
    else if (type === 'ugc') {  }
    else if (type === 'faq') initFaq(section);
    else if (type === 'ingredients') initIngredients(section);
  }

  function initAll() {
    var sections = $all('[data-cerus-component]');
    status('initAll — sections found:', sections.length, sections.map(function (s) { return s.getAttribute('data-cerus-component'); }));
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-cerus-component]');
    if (section) { section.dataset.cerusReady = ''; initSection(section); }
  });

  if (DEBUG_VERBOSE) {
    document.addEventListener('click', function (e) {
      var t = e.target;
      var sig = t.tagName + (t.id ? '#' + t.id : '') + (t.className && typeof t.className === 'string' ? '.' + t.className.split(/\s+/).slice(0, 3).join('.') : '');
      var purchase = t.closest && t.closest('[data-cerus-mode]');
      var flavor = t.closest && t.closest('.cerus-flavor');
      vdbg('CLICK', sig, '| purchase-mode:', purchase && purchase.dataset.cerusMode, '| flavor:', flavor && flavor.title);
    }, true);
  }

  CerusPdp.initSection = initSection;
  CerusPdp.debug = function () {

    var u = new URL(window.location.href);
    u.searchParams.set('cerusDebug', '1');
    window.location.href = u.toString();
  };
})();
